import { render, staticRenderFns } from "./FilterRevenue.vue?vue&type=template&id=72c8ec03&scoped=true"
import script from "./FilterRevenue.vue?vue&type=script&lang=js"
export * from "./FilterRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8ec03",
  null
  
)

export default component.exports